import {ChangeDetectorRef, Component, HostListener, OnInit} from '@angular/core';
import {UserSearch, UserSearchCity} from '@models/search';
import {PARTNER_MAX_SEARCH_CITY} from '@models/user';
import {AdService} from '@services/ad.service';
import {UserService} from '@services/user.service';
import {AlertService} from '@services/alert.service';
import {CommonService} from '@services/common.service';
import {CityService} from '@services/city.service';
import {MatDialog} from '@angular/material/dialog';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@services/authentification.service';
import {TrackingService} from '@services/tracking.service';
import {ConfirmComponent} from '@components/popup/confirm/confirm.component';
import {City} from '@models/city';
import {SaveCityComponent} from '@module/search/popup/save-city/save-city.component';
import {EVOL_DEMO_LAST_YEAR, SEARCH_CITY_PARAMS, SEARCH_PARAMS} from '@models/empty';
import {OnboardingService} from '@services/onboarding.service';
import {EditCityComponent} from '@module/search/popup/edit-city/edit-city.component';
import {DupplicateCityComponent} from '@module/search/popup/dupplicate-city/dupplicate-city.component';
import {UpgradePlanV2Component} from '@components/popup/upgrade-plan-v2/upgrade-plan-v2.component';
import {DemoAccountComponent} from '@components/popup/demo-account/demo-account.component';
import {TutoComponent} from '@components/popup/tuto/tuto.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ResultsFloatingBase} from '../results-floating-base';
import {TOO_MANY_REQUESTS} from '~/app/shared/helpers/error.interceptor';

@Component({
    selector: 'app-results-city',
    templateUrl: './results-city.component.html',
    styleUrls: ['./results-city.component.scss']
})
export class ResultsCityComponent extends ResultsFloatingBase implements OnInit {
    cities: City[] = [];
    cacheCities: City[] = [];
    loading = false;

    result = -1;
    params;
    onboarding = false;

    sort = 'name-asc';
    sortOptions = [
        {value: 'name-asc', label: 'Nom (A → Z)'},
        {value: 'name-desc', label: 'Nom (Z → A)'},
        {value: 'pop-desc', label: 'Population (Décroissant)'},
        {value: 'pop-asc', label: 'Population (Croissant)'},
        {value: 'efficiency-desc', label: 'Rendement (Décroissant)'},
        {value: 'efficiency-asc', label: 'Rendement (Croissant)'},
    ];

    currentSearch: UserSearchCity;
    userSearchs: UserSearchCity[] = [];

    page = 1;
    pages = [];

    constructor(
        cdr: ChangeDetectorRef,
        private adService: AdService,
        private userService: UserService,
        private alertService: AlertService,
        public commonService: CommonService,
        public cityService: CityService,
        private onboardingService: OnboardingService,
        public dialog: MatDialog,
        private location: Location,
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        private deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService) {
        super(cdr);
    }
    ngOnInit(): void {
        this.params = {'id': ''};
        if (this.authenticationService.isLogin) {
            this.adService.getUserSearchCity().subscribe(r => {
                if (this.authenticationService.isAllowed('essentiel')) {
                    this.userSearchs = r;
                }
                this.setParams();
            });
        } else {
            this.setParams();
        }

        this.onboardingService.listen().subscribe(elem => {
            if (elem == 'search_city_start') {
                this.onboarding = true;
                if (this.cities.length > 3) {
                    this.cacheCities = this.cities;
                    this.cities = [this.cities[0], this.cities[1]];
                }
            }
            if (elem == 'search_city_end') {
                // endVille() est aussi émis HORS onboarding (clic « Rechercher » des filtres) :
                // ne restaurer le cache que si un tour a réellement tronqué la liste,
                // sinon on écrase les résultats avec un cache vide -> liste vide
                if (this.onboarding === true) {
                    this.cities = this.cacheCities;
                }
                this.onboarding = false;
            }
        });
    }

    setParams() {
        this.route.params.subscribe(params => {
            this.params = params;
            if (params.id !== undefined) {
                if (params.id == 'result') {
                    this.userService.getCurrentSearchCity().subscribe(params => {
                        this.currentSearch = params;
                        this.search();
                    });
                } else {
                    this.setSearch();
                }
            }
        });
    }

    setSearch() {
        if (this.params.id !== undefined && this.userSearchs.length > 0) {
            if (this.authenticationService.isAllowed('essentiel')) {
                this.userSearchs.forEach(f => {
                    if (f.id === parseInt(this.params.id, 10)) {
                        this.currentSearch = f;
                        this.search();
                    }
                });
            } else {
                this.alertService.error('Cette fonctionnalité nécessite un plan supérieur, consultez nos forfaits dans Mon compte > Nos forfaits');
            }
        }
    }

    // Pagination côté serveur : on envoie page/per_page et on lit {cities, total, page}
    // (le back renvoie la tranche triée par nom ; sans filtre = toutes les communes)
    search(page = 1) {
        this.cities = [];

        this.loading = true;
        this.trackingService.searchCity();
        this.result = -1;
        this.page = page;
        const scp = this.currentSearch.search_city_params;
        this.sort = (scp.sort || 'name') + '-' + (scp.sort_order || 'asc');
        const params = Object.assign({}, scp, {page, per_page: 10});
        this.adService.searchCities(params).subscribe(res => {
            const cities = res && res.cities ? res.cities : (res || []);
            this.result = res && res.total != null ? res.total : cities.length;

            if (cities.length === 0) {
                if (page === 1) {
                    this.alertService.error('Aucun résultat');
                }
            } else {
                // Push synchrone : l'ordre trié du back est conservé, les images arrivent après
                cities.forEach(city => { this.cities.push(city); this.setImg(city); });
                if (this.onboarding === true) {
                    if (this.cities.length > 3) {
                        this.cacheCities = this.cities;
                        this.cities = [this.cities[0], this.cities[1]];
                    }
                }
            }

            this.buildPages();
            this.loading = false;
        }, error => {
            this.loading = false;
            if (error === TOO_MANY_REQUESTS) {
                this.result = 0;
                this.alertService.error(TOO_MANY_REQUESTS);
            } else {
                this.alertService.error('Une erreur est survenue');
            }
            console.log(error);
        });
    }

    loadResult(page) {
        this.search(page);
    }

    // Fenêtre de liens de pagination autour de la page courante, bornée au nombre total de pages
    private buildPages() {
        let page_first = 0;
        let page_last = 0;

        if (this.deviceService.isMobile()) {
            if (this.page > 3) {
                page_first = this.page - 3;
                page_last = this.page + 3;
            } else {
                page_first = 1;
                page_last = 6;
            }
        } else {
            if (this.page > 6) {
                page_first = this.page - 5;
                page_last = this.page + 5;
            } else {
                page_first = 1;
                page_last = 10;
            }
        }

        const totalPages = Math.ceil(Math.max(this.result, 0) / 10);
        if (page_last > totalPages) {
            page_last = totalPages;
        }

        this.pages = [];
        for (let i = page_first; i <= page_last; i++) {
            this.pages.push(i);
        }
    }

    setImg(city: City) {
        let zip_code = city.zip_code;
        let name = city.name;
        if (zip_code.slice(0, 3) === "750" || zip_code.slice(0, 3) === "690" || zip_code.slice(0, 3) === "130") {
            const arrondissement = zip_code.slice(3, 5); // 2 derniers chiffres
            name += (arrondissement === "01" ? "er" : "eme") + " arrondissement";
        }

        this.http.get<any>('https://fr.wikipedia.org/w/api.php?action=query&origin=*&format=json&generator=search&gsrsearch=' + name + ' ' + zip_code + '('+city.departement+')&gsrnamespace=0&gsrlimit=1&prop=pageimages&piprop=thumbnail&pilimit=max&pithumbsize=400').subscribe(r => {
            if (Object.values(r.query.pages)[0]['thumbnail'] == undefined || Object.values(r.query.pages)[0]['thumbnail'] == '') {
                this.http.get<any>('https://fr.wikipedia.org/w/api.php?action=query&origin=*&format=json&generator=search&gsrsearch=' + name + '('+city.departement+')&gsrnamespace=0&gsrlimit=1&prop=pageimages&piprop=thumbnail&pilimit=max&pithumbsize=400').subscribe(r => {
                    if (Object.values(r.query.pages)[0] && Object.values(r.query.pages)[0]['thumbnail'] && Object.values(r.query.pages)[0]['thumbnail']['source']) {
                        city.image = Object.values(r.query.pages)[0]['thumbnail']['source'];
                    }
                }, error => {
                });
            } else {
                city.image = Object.values(r.query.pages)[0]['thumbnail']['source'];
            }
        }, error => {
        });
    }

    deleteSearch() {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '420px',
            data: {message: 'Êtes-vous sûr de vouloir supprimer le secteur "' + this.currentSearch.title + '"'},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.trackingService.click('search_city_result_search_delete_confirm', this.currentSearch.id);
                this.adService.deleteSearchCity(this.currentSearch).subscribe(r => {
                    this.alertService.success('Recherche supprimée.');
                    this.router.navigate(['/app/city']);
                    this.alertService.success('Recherche supprimée.', true);
                }, error => {
                    this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                });
            }
        });
    }

    editSearch() {
        const dialogRef = this.dialog.open(EditCityComponent, {
            width: '420px',
            position: {top: (this.deviceService.isMobile() ? '55px' : '')},
            data: {userSearch: this.currentSearch},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.alertService.success("Enregistrement réussi.");
                this.trackingService.click('search_city_result_search_rename_confirm', this.currentSearch.id);
                this.userSearchs.forEach(s => {
                    if (s.id === result.currentSearch.id) {
                        this.currentSearch = s;
                    }
                });
            } else {
                this.trackingService.click('search_city_result_search_rename_cancel', this.currentSearch.id);
            }
        });
    }

    duplicateSearch() {
        if (this.authenticationService.isPartner && this.userSearchs.length >= PARTNER_MAX_SEARCH_CITY) {
            this.showDemoAccount();
            return;
        }
        const dialogRef = this.dialog.open(DupplicateCityComponent, {
            width: '420px',
            position: {top: (this.deviceService.isMobile() ? '55px' : '')},
            data: {userSearch: this.currentSearch},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                this.alertService.success("Enregistrement réussi.");
                this.trackingService.click('search_city_result_search_duplicate_confirm', this.currentSearch.id);
                this.userSearchs.push(result.currentSearch);
                this.userSearchs.forEach(s => {
                    if (s.id === result.currentSearch.id) {
                        this.currentSearch = s;
                        this.params = {id: this.currentSearch.id};
                        this.location.replaceState('/app/city/' + this.currentSearch.id);
                    }
                });
            } else {
                this.trackingService.click('search_result_search_duplicate_cancel', this.currentSearch.id);
            }
        });
    }

    showDemoAccount() {
        if (this.dialog.openDialogs.length === 0) {
            this.dialog.open(DemoAccountComponent, {width: '420px'});
        }
    }

    saveSearch() {
        if (!this.authenticationService.isAllowed('essentiel')) {
            const dialogRef = this.dialog.open(UpgradePlanV2Component, {
                width: '520px',
                data: {visuel: 'assets/upgrade/map-city-search.png', plan: 'Essentiel', feature: 'Recherche des villes rentables'}
            });
        } else if (this.authenticationService.isPartner && this.userSearchs.length >= PARTNER_MAX_SEARCH_CITY) {
            this.showDemoAccount();
        } else {
            const dialogRef = this.dialog.open(SaveCityComponent, {
                width: '480px',
                position: {top: (this.deviceService.isMobile() ? '55px' : '')},
                data: {searchParams: this.currentSearch.search_city_params, userSearch: this.currentSearch, userSearchs: this.userSearchs},
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== false && result !== undefined) {
                    this.trackingService.click('search_result_search_save_confirm', this.currentSearch.id);
                    this.userSearchs.push(result.currentSearch);
                    this.userSearchs.forEach(s => {
                        if (s.id === result.currentSearch.id) {
                            this.currentSearch = s;

                            var currentSearch: UserSearch = ({} as UserSearch);
                            currentSearch.search_ad_params = JSON.parse(JSON.stringify(SEARCH_PARAMS)); // clone : ne pas contaminer la constante partagée
                            currentSearch.search_ad_params.price = [0, 1000000];
                            currentSearch.search_ad_params.surface = [0, ];
                            currentSearch.search_ad_params.rendement = [0, 25];
                            currentSearch.search_ad_params.cities = [];
                            currentSearch.search_ad_params.search_city_params_id = this.currentSearch.id;
                            this.userService.setCurrentSearch(currentSearch);
                            this.router.navigate(['/app/search/result']);
                        }
                    });
                }
            });
        }
    }

    loadSearch(event) {
        this.params = {id: this.currentSearch.id};
        this.location.replaceState('/app/city/' + this.currentSearch.id);
        this.search();
    }

    // Recherche dans le sélecteur de secteurs (mobile)
    searchListText = '';

    get filteredUserSearchs(): UserSearchCity[] {
        return this.searchListText
            ? this.userSearchs.filter(s => s.title.toLowerCase().includes(this.searchListText.toLowerCase()))
            : this.userSearchs;
    }

    // Nouveau secteur : ouvre les filtres avec les valeurs par défaut (pas les filtres en cours)
    // Nouveau secteur : vide les filtres puis ouvre le bandeau de filtres
    // (desktop) ou la page filtres (mobile, pas de bandeau sous 768px)
    newSearch() {
        const search = ({} as UserSearchCity);
        search.search_city_params = JSON.parse(JSON.stringify(SEARCH_CITY_PARAMS));
        this.userService.setCurrentSearchCity(search);
        if (window.innerWidth < 768) {
            this.router.navigate(['/app/city/result/filters']);
            return;
        }
        if (this.params.id == 'result') {
            this.currentSearch = search;
            this.search();
        } else {
            this.router.navigate(['/app/city/result']);
        }
        this.openFiltersDrawer();
    }

    // Bornes des filtres à plage (mêmes valeurs que les sliders des filtres secteur) :
    // une plage qui couvre toute la borne = valeur par défaut, donc filtre inactif
    private static readonly RANGE_BOUNDS = {
        pop: [0, 150000],
        mv: [0, 40000],
        tc: [0, 30],
        te: [0, 30],
        tv: [0, 30],
        tl: [0, 80],
        tensiometre: [0, 8],
        squarePriceCity: [0, 10000],
        efficiencyCity: [0, 10],
        squareRent: [0, 50],
        priceEvolCity_1: [-100, 100],
        priceEvolCity_3: [-100, 100],
        priceEvolCity_5: [-100, 100],
        priceEvolCity_10: [-100, 100],
    };

    private rangeActive(key: string, value: any): boolean {
        if (!value || !value.length) {
            return false;
        }
        const num = x => typeof x === 'number' && !isNaN(x);
        const bounds = ResultsCityComponent.RANGE_BOUNDS[key];
        return (num(value[0]) && value[0] > bounds[0]) || (num(value[1]) && value[1] < bounds[1]);
    }

    // Nombre de filtres actifs = qui diffèrent des valeurs par défaut
    getSortLabel(): string {
        const opt = this.sortOptions.find(o => o.value === this.sort);
        return opt ? opt.label : '';
    }

    setSort() {
        this.currentSearch.search_city_params.sort = this.sort.split('-')[0];
        this.currentSearch.search_city_params.sort_order = this.sort.split('-')[1];
        if (this.params.id != 'result' && this.currentSearch.id) {
            this.adService.editUserSearchCity(this.currentSearch).subscribe(() => {});
        } else {
            this.userService.setCurrentSearchCity(this.currentSearch);
        }
        this.search();
    }

    // --- Bandeau de filtres desktop (drawer à droite, résultats mis à jour en direct) ---
    // filtersDrawer / saveFloating* / scroll : hérités de ResultsFloatingBase

    openFiltersDrawer() {
        this.trackingService.click('search_city_filter', this.currentSearch && this.currentSearch.id ? this.currentSearch.id : 'result');
        this.filtersDrawer = true;
    }

    onDrawerParams(params) {
        // Le tri reste piloté par la page résultats
        params.sort = this.currentSearch.search_city_params.sort;
        params.sort_order = this.currentSearch.search_city_params.sort_order;
        this.currentSearch.search_city_params = params;
        if (this.params.id != 'result' && this.currentSearch.id) {
            this.adService.editUserSearchCity(this.currentSearch).subscribe(() => this.search());
        } else {
            this.userService.setCurrentSearchCity(this.currentSearch);
            this.search();
        }
    }

    getActiveFilterCount(): number {
        if (!this.currentSearch || !this.currentSearch.search_city_params) {
            return 0;
        }
        const p = this.currentSearch.search_city_params;
        let count = 0;
        if ((p.cities_include || []).length) { count++; }
        if ((p.cities_exclude || []).length) { count++; }
        if ((p.region || []).length || (p.departement || []).length) { count++; }
        if (p.coeur_de_ville) { count++; }
        if (p.denormandie) { count++; }
        if ((p.evol_demo || []).length) { count++; }
        Object.keys(ResultsCityComponent.RANGE_BOUNDS).forEach(k => {
            if (this.rangeActive(k, p[k])) { count++; }
        });
        return count;
    }

    toFloat(s) {
        return parseFloat(s);
    }

    openTuto() {
        const dialogRef = this.dialog.open(TutoComponent, {
            width: '1000px',
            data: {video: 'city_search'}
        });
    }

    protected readonly EVOL_DEMO_LAST_YEAR = EVOL_DEMO_LAST_YEAR;
}
